import * as React from 'react';
import { SVGProps } from 'react';
const SvgIcAlert = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={32}
    height={32}
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g fill="none" fillRule="evenodd">
      <path
        d="M15.392 3.636a2 2 0 0 1 2.385.988l11.076 21.459c.253.49.284 1.037.128 1.525A1.994 1.994 0 0 1 27.076 29H4.924a1.994 1.994 0 0 1-1.414-.586 1.994 1.994 0 0 1-.363-2.331l11.076-21.46c.253-.49.681-.832 1.169-.987Z"
        stroke="#B0322B"
        strokeWidth={2}
      />
      <path
        d="M17 10v11h-2V10h2Zm-1 16a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"
        fill="#B0322B"
      />
    </g>
  </svg>
);
export default SvgIcAlert;
